<template>
  <div class="container flex-center" :style="'--highlight-color: '+ company.highlight +';'">
    <div class="card card__md">
      <loader v-if="!loaded" />
      <button
        class="button button__rounded button__return"
        @click="$router.push({ name: 'Index' })"
      >
        <span>Palaa takaisin</span>
      </button>
      <form v-if="event" @submit.prevent="onSubmit">
        <Input
          type="text"
          name="title"
          label="Lisää otsikko"
          v-model="event.title"
          :hasError="errors.title"
        />
        <div class="radio-wrapper">
          <span class="radio-wrapper__title">
            Valitse yksi tai useampi kategoria:
          </span>
          <div class="radio-wrapper__row">
            <div
              v-for="category in categories"
              :key="category.title"
              class="radio-field"
            >
              <label class="radio-field__label">
                {{ category.title }}
                <input
                  type="radio"
                  :id="category"
                  :value="category"
                  v-model="event.category"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="date-wrapper">
          <Datepicker
            :icon="true"
            name="dateFrom"
            label="Tapahtuma alkaa"
            v-model="event.start"
            :initialDate="event.start"
            :hasError="errors.start"
          />
          <span class="line"></span>
          <Datepicker
            name="dateTo"
            label="Tapahtuma päättyy"
            v-model="event.end"
            :initialDate="event.end"
            :hasError="errors.end"
          />
        </div>
        <div v-if="event.fileUrlUploaded" class="event-file">
          <p class="sm">Liite</p>
          <div class="event-file__input">
            <a
              :href="event.fileUrlUploaded"
              target="_blank"
              v-html="parseFileUrl(event.fileUrlUploaded)"
            >
            </a>
            <i @click="deleteFile(event.id)" class="icon icon--x"></i>
          </div>
        </div>
        <file-select
          v-else
          folder="/files/"
          :action="fileUploadAction"
          @status-updated="onFileStatusUpdated"
        />
        <Textarea
          v-model="event.description"
          placeholder="Lisää kuvaus"
          name="description"
          :hasError="errors.description"
        />
        <button type="submit" class="button button__rounded button__submit">
          <span>Päivitä tapahtuma</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import db from "@/firebase/init";
import { mapState } from "vuex";
import slugify from "slugify";

import Loader from "@/components/Loader";
import Input from "@/components/Input";
import Datepicker from "@/components/Datepicker";
import FileSelect from "@/components/FileSelect";
import Textarea from "@/components/Textarea";

export default {
  name: "EventForm",
  components: {
    Loader,
    Input,
    Datepicker,
    FileSelect,
    Textarea
  },
  data() {
    return {
      event: null,
      categories: [],
      another: null,
      loaded: false,
      companyId: null,
      fileUrlUploaded: null,
      fileUploadStatus: "init",
      fileUploadAction: "init",
      errors: {},
      unsubscribe: null
    };
  },
  computed: {
    ...mapState(["user", "companies"])
  },
  destroyed() {
    if(this.unsubscribe != null) {
      this.unsubscribe();
    }
  },
  created() {
    setTimeout(() => {
      this.fileAction = "upload";
    }, 1000);

    if (this.$route.params.companyId) {
      this.$store.commit("SET_COMPANY_BY_ID", this.$route.params.companyId);
    } else {
      this.$store.commit("SET_DEFAULT_COMPANY");
    }

    this.company = this.companies[this.$route.params.companyId];
    this.categories = this.company.categories;

    let ref = db
      .collection(`companies/${this.company.id}/events`)
      .where("slug", "==", this.$route.params.event_slug);
    this.unsubscribe = ref.onSnapshot(snapshot => {
      snapshot.forEach(doc => {
        this.loaded = true;
        this.event = doc.data();
        this.event.id = doc.id;
      });
    });

    // let user = firebase.auth().currentUser;
    //     let uid = user.uid;

    //     db.collection("users")
    //       .doc(uid)
    //       .get()
    //       .then(doc => {
    //         let data = doc.data();
    //         this.companyId = data.companyId;
    //       })
    //       .then(() => {
    //         db.collection("companies")
    //           .doc(this.companyId)
    //           .get()
    //           .then(doc => {
    //             let company = doc.data();
    //             company.categories.map(category => {
    //               this.categories.push(category);
    //             });
    //           });
    //       })
    //       .then(() => {

    //       });
  },
  methods: {
    parseFileUrl(url) {
      if (url) {
        const filename = url.split("?");
        url = filename[0].replace("files%", "");
        url.replace("files%", "");
        return url.substr(url.lastIndexOf("/") + 1);
      }
    },
    deleteFile(id) {
      const ref = db.collection(`companies/${this.company.id}/events`).doc(id);
      ref.update({
        fileUrlUploaded: firebase.firestore.FieldValue.delete()
      });
    },
    onFileStatusUpdated(status) {
      console.log("Video status updtaed", status);
      switch (status.status) {
        case "ready_for_upload":
          this.fileUploadStatus = status.status;
          break;
        case "upload_complete":
          this.fileUrlUploaded = status.url;
          this.editEvent();
          break;
        case "error":
          console.log("status.error");
          break;
        default:
          break;
      }
    },
    onSubmit() {
      if (this.fileUploadStatus === "ready_for_upload") {
        this.fileUploadAction = "upload";
      } else {
        this.editEvent();
      }
    },
    editEvent() {
      if (this.event.title) {
        this.event.slug = slugify(this.event.title, {
          replacement: "-",
          remove: /[$*_+~()'"!\-:@]/g,
          lower: true
        });

        const editedEvent = {
          title: this.event.title,
          slug: this.event.slug,
          start: this.event.start,
          end: this.event.end,
          category: this.event.category,
          fileUrlUploaded: this.fileUrlUploaded,
          description: this.event.description,
          updatedAt: new Date()
        };

        db.collection(`companies/${this.company.id}/events`)
          .doc(this.event.id)
          .set(editedEvent, { merge: true })
          .then(() => {
            console.log("Successfully updated!");

            if (this.user.companyId === this.company.id) {
              this.$router.push({ name: "Index" });
            } else {
              this.$router.push({
                name: "IndexCompany",
                params: { companyId: this.company.id }
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        // Error
      }
    }
  }
};
</script>

<style lang="scss">
.edit-event {
  width: 100%;
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &__wrapper {
    max-width: 40em;
    background: white;
    border-radius: 2.5em;
    padding: 3em 5em;
  }
}

.event-file {
  padding: 0 2.5em;
  color: $lightred;
  &__input {
    display: flex;
    flex-direction: row;
    align-items: center;
    a {
      color: black;
      transition: $transition;
      &:hover {
        color: $lightred;
        transition: $transition;
      }
    }
    i {
      width: 0.75em;
      height: 0.75em;
      cursor: pointer;
    }
  }
}

.btn-return {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
  margin-bottom: 2em;
  padding: 0.5em 2em;
  font-size: 1.6rem;
  font-weight: 500;
  color: $lightred;
  background: transparent;
  border-radius: 2.5em;
  border: 1px solid $lightred;
  outline: 0;
  box-shadow: none;
  transition: $transition;
  cursor: pointer;

  &:hover {
    box-shadow: $shadow_sm;
    transition: $transition;
  }
}
</style>
